import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaViewSwitch',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const OPTIONS = [
            { value: "new", label: "New look", icon: "mdi-creation-outline" },
            { value: "classic", label: "Classic", icon: "mdi-view-agenda-outline" },
        ];
        function select(view) {
            if (view && view !== props.modelValue)
                emit("update:modelValue", view);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_btn_toggle = _resolveComponent("v-btn-toggle");
            return (_openBlock(), _createBlock(_component_v_btn_toggle, {
                "model-value": __props.modelValue,
                class: "view-switch",
                mandatory: "",
                divided: "",
                density: "compact",
                variant: "outlined",
                rounded: "lg",
                "aria-label": "Page view",
                "onUpdate:modelValue": select
            }, {
                default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(OPTIONS, (option) => {
                        return _createVNode(_component_v_btn, {
                            key: option.value,
                            value: option.value,
                            class: "view-switch__option"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                    size: "15",
                                    start: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(option.icon), 1)
                                    ]),
                                    _: 2
                                }, 1024),
                                _createTextVNode(" " + _toDisplayString(option.label), 1)
                            ]),
                            _: 2
                        }, 1032, ["value"]);
                    }), 64))
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
